import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-account-deletion',
	templateUrl: './account-deletion.component.html',
	styleUrls: ['./account-deletion.component.css']
})
export class AccountDeletionComponent implements OnInit {
	constructor() { }

	ngOnInit(): void {
	}
}